// Path: ./src/app/components/CustomAutocomplete/styled.ts
import styled from "styled-components";

interface SelectedOptionsProps {
  openDrop: boolean;
  inputCss?: string;
}

interface WrapperProps {
  WrapperCss?: string;
}
export const Container = styled.div`
  display: inline-block;
  width: 100%;
  outline: none;

  &:focus {
    outline: none;
  }
`;
export const Wrapper = styled.div<WrapperProps>`
  ${({ WrapperCss }) => WrapperCss && `${WrapperCss}`}
`;

interface titleCssProps {
  titleCss?: string;
}
export const Title = styled.div<titleCssProps>`
  padding: 0 0 4px;
  line-height: 1.5;
  font-size: 16px;
  display: block;
  ${({ titleCss }) => titleCss && `${titleCss}`}
`;

export const SelectedOptions = styled.div<SelectedOptionsProps>`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  padding: 4px;
  width: 100%;
  max-width: 600px;
  padding: 4px 6px;
  max-height: 150px;
  flex-wrap: wrap;
  overflow: scroll;
  background-color: white;
  outline: none;
  &:hover {
    border-color: #ff8038;
    box-shadow: 0 0 0 2px #ff813863;
  }
  ${({ openDrop }) =>
    openDrop &&
    `
      border-color: #ff8038;
      box-shadow: 0 0 0 2px #ff813863;
    `}
  ${({ inputCss }) => inputCss && `${inputCss}`}
`;

export const SelectedOption = styled.div`
  background-color: #fafafa;
  color: #333;
  padding: 1px 6px;
  display: flex;
  align-items: center;
  margin: 2px;
  line-height: 22px;
  background-color: #fafafa;
  border: 1px solid #e8e8e8;
  border-radius: 2px;
  box-sizing: content-box;
  outline: 0;
  overflow: hidden;
`;
export const OptionText = styled.div`
  font-size: 14px;
  line-height: 22px;
`;

interface InputTextCssProps {
  inputTextCss?: string;
}

export const Input = styled.input<InputTextCssProps>`
  border: none;
  outline: none;
  flex-grow: 1;
  width: 100%;
  max-width: 600px;
  padding: 4px 6px;
  max-height: 150px;
  ${({ inputTextCss }) => inputTextCss && `${inputTextCss}`}
`;

interface SelectListCssProps {
  selectListCss?: string;
}

export const OptionsList = styled.ul<SelectListCssProps>`
  list-style: none;
  border: 1px solid #ccc;
  border-top: none;
  width: 100%;
  z-index: 1700;
  margin: 2px 0 0;
  padding: 0;
  position: absolute;
  background-color: #fff;
  overflow: auto;
  max-height: 250px;
  max-width: 300px;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  ${({ selectListCss }) => selectListCss && `${selectListCss}`}
`;

interface OptionProps {
  selected?: boolean;
  isSelectAllOption?: boolean;
  highlighted?: boolean;
}

export const Option = styled.li<OptionProps>`
  display: flex;
  align-items: start;
  justify-content: space-between;
  cursor: pointer;
  background-color: white;
  line-height: 1.5;
  letter-spacing: 0.00938em;
  padding: 5px 12px;

  font-weight: ${({ selected }) => (selected ? "bold" : "normal")};
  ${({ isSelectAllOption }) =>
    isSelectAllOption &&
    `
      border-bottom: 1px solid #ccc;
    `}
  ${({ highlighted }) =>
    highlighted &&
    `
      background-color: #ff813896;
    `}
  &:hover {
    background-color: #ff813896;
  }
`;

export const UnselectButton = styled.button.attrs({ type: "button" })`
  margin-left: 8px;
  background: none;
  border: none;
  color: black;
  cursor: pointer;
`;

export const SelectedIcon = styled.div<OptionProps>`
  margin-left: 8px;
  background: none;
  border: none;
  font-size: 12px;
  color: black;
  ${({ selected }) =>
    selected &&
    `
     color: #fa742795;
  
    `}
`;
